/**
 * Project page, the front — what people see: screenshots in browser
 * windows, text blocks, phone captures on a sideways strip, quotes. One
 * block per entry of the project's `sections` (features go to the back).
 * The markup is the server's (templates/site/sections/project/front.html.twig).
 *
 * @module sections/project/front
 */

import { REDUCED_MOTION } from '../../config.js';
import { $$ } from '../../lib/dom.js';
import { gsap } from '../../lib/gsap.js';

/**
 * Screenshots drift inside their browser window (the cover of the opening
 * included), scaled a little so the drift never uncovers the frame.
 */
export function animate() {
    if (REDUCED_MOTION) {
        return;
    }

    $$('[data-parallax-img]').forEach((image) => {
        gsap.fromTo(
            image,
            { scale: 1.08, yPercent: -3 },
            {
                scale: 1.08,
                yPercent: 3,
                ease: 'none',
                scrollTrigger: { trigger: image.parentElement, start: 'top bottom', end: 'bottom top', scrub: true },
            },
        );
    });
}
